/**
 * Spine (kernel-native: the kernel is the system of record; no coreBOS module yet).
 * Organigram: departments/offices. People belong to units; processing and policies apply to units.
 * Hand-written (ADR-029 §4); links to other spines are graph edges, see src/spines.ts.
 */
export const orgUnitDescriptor = {
    slug: 'cmp_org_unit',
    kind: 'document',
    label: { singular: 'Unità organizzativa', plural: 'Unità organizzative' },
    table: 'compliance_org_unit',
    idStrategy: 'sha256',
    fields: [
        { name: 'name', type: 'text', label: 'Nome', required: true },
        { name: 'code', type: 'text', label: 'Codice' },
        { name: 'description', type: 'text', label: 'Descrizione' },
    ],
    relations: [
        { name: 'organisation', kind: 'belongsTo', target: 'account', toEntitySpine: true },
        { name: 'parent', kind: 'belongsTo', target: 'cmp_org_unit' },
        { name: 'head', kind: 'belongsTo', target: 'contact', toEntitySpine: true },
    ],
    behaviors: { audit: true, softDelete: true, tenantScoped: true },
    ui: { mode: 'generated', icon: 'ApartmentOutlined', navGroup: 'Organizzazione' },
};
